import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Dashboard from '../pages/Dashboard';

const HomeRedirect: React.FC = () => {
  const { user } = useAuth();

  if (user?.role === 'coach' || user?.role === 'entreprise') {
    return <Navigate to="/tracking" replace />;
  }

  return <Dashboard />;
};

export default HomeRedirect;
